import {
  Component,
  OnInit,
  ViewChildren,
  TemplateRef,
  Input,
} from "@angular/core";
import { AppService } from "../services/app.service";
import { SupportService } from "../services/support-service";
import { Location } from "@angular/common";
import { FormControl } from "@angular/forms";
import { Subscription } from "rxjs";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";

@Component({
  selector: "app-schedmed-review",
  templateUrl: "./schedmed-review.component.html",
})
export class SchedmedReviewComponent implements OnInit {
  rowsData = [
    { title: "Name", sorting: true, name: "patientFirstName" },
    { title: "Star Rating" },
    {
      title: "Date Received",
      sorting: true,
      name: "scheduledOn",
      dateFitler: true,
    },
    { title: "Patient I/C" },
    { title: "Comments" },
  ];
  @ViewChildren("template, templateReview") templates;
  modalRef: BsModalRef;
  @Input() public fullView = true;
  @Input() public modalName: string;
  columnsData = [];
  columnsRes = [];
  p = 1;
  totalItems: any;
  currentPage = 1;
  page: number;
  maxSize = 10;
  maxSizeItem = 10;
  firstNameControl = new FormControl();
  formCtrlSub: Subscription;
  searchPatient = "";
  sortColumn = "scheduledOnStr";
  orderColumn = "desc";
  searchText = "";
  alphaVal = "all";
  routerName = "";
  maxSizeItemValue: any;
  dailypageno = 1;

  constructor(
    private appService: AppService,
    private supportService: SupportService,
    private location: Location,
    private modalService: BsModalService
  ) {}

  ngOnInit() {
    this.getScedmedReviewAdmin("");

    this.supportService.gridSortingHeader.subscribe((res) => {
      if (res && res["length"] !== 0 && res["routerName"] === this.routerName) {
        this.sortColumn = res["name"];
        this.orderColumn = res["order"];
        const event = {
          page: 1,
        };
        this.currentPage = 1;
        this.getScedmedReviewAdmin(event);
      }
    });
    this.checkUrl();
  }

  checkUrl() {
    const path = this.location.path().split("/");
    if (path.length === 3) {
      this.routerName = path[2];
    }
  }

  onBlurSearchMethod() {
    this.searchPatient = this.searchText;
    this.currentPage = 1;
    this.getScedmedReviewAdmin("");
  }

  refreshPatient() {
    this.searchText = "";
    this.searchPatient = "";
    this.getScedmedReviewAdmin("");
  }

  getScedmedReviewAdmin(event) {
    let data;
    if (event) {
      data = {
        tcId: "",
        type: "patient",
        pagenumber: event.page,
        pagesize: this.maxSizeItem,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        search: this.searchPatient,
        patientType: "IC",
      };
    } else {
      data = {
        tcId: "",
        type: "patient",
        pagenumber: 1,
        pagesize: this.maxSizeItem,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        search: this.searchPatient,
        patientType: "IC",
      };
    }

    this.appService.getAllReviewByTc(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.columnsData = res["entity"];
            this.totalItems = res["count"];
          }
        } else {
          this.columnsData = [];
          this.totalItems = 0;
        }
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }

  pageChanged(event: any): void {
    this.page = event.page;
    this.getScedmedReviewAdmin(event);
  }

  openModal(templateSchedReview: TemplateRef<any>, datavalue) {
    this.rowsData = datavalue;
    this.modalRef = this.modalService.show(
      templateSchedReview,
      Object.assign({}, { class: "modal-md" })
    );
  }
}
